import { render } from "./UiLoader.vue?vue&type=template&id=02655f44&scoped=true"
import script from "./UiLoader.vue?vue&type=script&lang=js"
export * from "./UiLoader.vue?vue&type=script&lang=js"

import "./UiLoader.vue?vue&type=style&index=0&id=02655f44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02655f44"]])

export default __exports__